import classnames from 'classnames';
import { useMemo } from 'react';

import { IconArrowLeft, IconArrowRight } from '../icons/icons';
import styles from './styles.module.less';

const Pagination = ({
  total,
  current,
  onChange
}: {
  total: number;
  current: number;
  onChange: (current: number) => void;
}) => {
  const lastPage = useMemo(() => {
    if (total === 0) return 1;
    return Math.ceil(total / 10);
  }, [total, current]);
  const disabledPre = current === 1;
  const disabledNext = current === lastPage;
  if (total === 0) {
    return <></>;
  }
  return (
    <div className={styles.box}>
      <IconArrowLeft
        onClick={() => {
          if (disabledPre) return;
          onChange?.(current - 1);
        }}
        className={classnames(styles.icon, {
          [styles.disabled]: disabledPre
        })}
      />
      <div className={styles.main}>
        <span>{current}</span>
        <span>/</span>
        <span>{lastPage}</span>
      </div>
      <IconArrowRight
        onClick={() => {
          if (disabledNext) return;
          onChange?.(current + 1);
        }}
        className={classnames(styles.icon, {
          [styles.disabled]: disabledNext
        })}
      />
    </div>
  );
};

export default Pagination;
